import React from 'react';
import { Col } from 'reactstrap';
import { motion, AnimatePresence } from 'framer-motion';

const TextInput = ({
  disabled,
  label,
  required,
  id_val,
  name,
  handleChange,
  error_stat,
  err_Msg,
  onFocus,
  colSize,
  type,
  maxlength,
  minlength,
  max,
  value,
  min,
  onBlur,
  parentClassName
}) => {
  return (
    <Col lg={colSize ? colSize : "6"} className={parentClassName}>
      <motion.div
        className="form-group"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {label && (
          <motion.div
            className="form-label-group"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.3 }}
          >
            <label className="form-label" htmlFor={id_val}>
              {label}
              {required && (
                <motion.span
                  className="text-danger pr-2"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {` *`}
                </motion.span>
              )}
            </label>
          </motion.div>
        )}

        <motion.div
          className="form-control-wrap"
          whileFocus={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <input
            required={required}
            onChange={handleChange}
            type={type}
            id={id_val}
            max={type === "date" || type === "number" ? max : ""}
            className="form-control"
            name={name}
            min={type === "date" || type === "number" ? min : ""}
            value={value}
            maxLength={maxlength ? maxlength : ""}
            minLength={minlength ? minlength : ""}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </motion.div>

        <AnimatePresence>
          {error_stat && (
            <motion.span
              className="text-danger"
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.25 }}
            >
              {err_Msg}
            </motion.span>
          )}
        </AnimatePresence>
      </motion.div>
    </Col>
  );
};

export default TextInput;
